var _path, _ellipse, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 56.4467C9.5 75.706 21.3253 89.1693 32.348 97.5273C39.003 102.523 46.3024 106.596 54.048 109.637C54.5769 109.836 55.1089 110.026 55.644 110.207L56.1667 110.393L56.6893 110.207C57.7151 109.854 58.7313 109.475 59.7367 109.068C66.9479 106.092 73.7532 102.214 79.99 97.5273C91.0033 89.1693 102.833 75.706 102.833 56.4467V18.8333L56.1667 2.5L9.5 18.8333V56.4467ZM60.8333 40.1133H51.4813V30.7613H60.8333V40.1133ZM51.5 77.4467V47.1133H60.8333V77.4467H51.5Z",
    fill: "#B72318"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.668,
    cy: 53.9473,
    rx: 17.5,
    ry: 31.5,
    fill: "#B72318"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5004 35.0624C53.6803 35.0449 50.8848 35.5875 48.276 36.6586C45.6672 37.7298 43.297 39.3082 41.3028 41.3023C39.3087 43.2965 37.7303 45.6667 36.6591 48.2755C35.588 50.8843 35.0454 53.6798 35.0629 56.4999C35.0454 59.32 35.588 62.1155 36.6591 64.7243C37.7303 67.3331 39.3087 69.7034 41.3028 71.6975C43.297 73.6917 45.6672 75.2701 48.276 76.3412C50.8848 77.4123 53.6803 77.9549 56.5004 77.9374C59.3205 77.9549 62.116 77.4123 64.7248 76.3412C67.3336 75.2701 69.7038 73.6917 71.698 71.6975C73.6921 69.7034 75.2705 67.3331 76.3417 64.7243C77.4128 62.1155 77.9554 59.32 77.9379 56.4999C77.9554 53.6798 77.4128 50.8843 76.3417 48.2755C75.2705 45.6667 73.6921 43.2965 71.698 41.3023C69.7038 39.3082 67.3336 37.7298 64.7248 36.6586C62.116 35.5875 59.3205 35.0449 56.5004 35.0624ZM64.8381 67.2187L45.7817 48.1638L48.1643 45.7812L67.2192 64.8376L64.8381 67.2187Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/Shield.18869a132912f11174c9001e8ad2cb15.svg";
export { ForwardRef as ReactComponent };